const isErrorModalOpen = ref(false);
const errorTitle = ref("");
const errorMessage = ref("");

export function useErrorModal() {
  function showError(options: { title: string; message: string }) {
    errorTitle.value = options.title;
    errorMessage.value = options.message;
    isErrorModalOpen.value = true;
  }

  return {
    isErrorModalOpen,
    errorTitle,
    errorMessage,
    showError
  };
}
